module.exports = __webpack_public_path__ + "media/icons/paliwo-title@3x-e471853d.svg";